export const formatMoney = function (price, format, removeDecimals, roundDecimals, roundDecimalsValue) {

    "string" == typeof price ? price = price.replace(".", "") : price *= 100;
    var result = "";
    var regEx = /\{\{\s*(\w+)\s*\}\}/;
    format = format || "${{amount}}"; //eslint-disable-line

    function symbolFormat(s1, s2) {
        return void 0 === s1 ? s2 : s1;
    }

    function runFormat(price, decimals, dot, comma) {
        if (isNaN(price) || null == price) {
            return 0;
        }

        decimals = symbolFormat(decimals, 2);
        dot = symbolFormat(dot, ",");
        comma = symbolFormat(comma, ".");

        var res = (price = price.toFixed(decimals)).split(".");
        return res[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + dot) + (res[1] ? comma + res[1] : "");
    }

    price = price / 100;

    if (removeDecimals) {
        price = Math.round(price);
    }
    else if (roundDecimals) {
        var originalPrice = price;
        price = Math.round(price);
        var lPrice = price - 1 + parseInt(roundDecimalsValue) / 100;
        var hPrice = price + parseInt(roundDecimalsValue) / 100;
        if (Math.abs(lPrice - originalPrice) < Math.abs(hPrice - originalPrice)) {
            price = lPrice;
        }
        else {
            price = hPrice;
        }
    }

    switch (format.match(regEx)[1]) {
        case "amount":
            result = runFormat(price, 2);
            break;
        case "amount_no_decimals":
            result = runFormat(price, 0);
            break;
        case "amount_with_comma_separator":
            result = runFormat(price, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            result = runFormat(price, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            result = runFormat(price, 0, " ", "");
            break;
        default:
            break;
    }

    var formatedResult = format.replace(regEx, result);
    return new DOMParser().parseFromString(formatedResult, "text/html").documentElement.textContent;
};

export const getCurrencySymbol = function (format) {
    format = format || "${{amount}}"; //eslint-disable-line
    format = new DOMParser().parseFromString(format, "text/html").documentElement.textContent;

    var regEx = /\{.*?\}}/;
    format = format.replace(regEx, '').trim();
    var splited = format.split(' ');
    if (splited.length > 0) {
        format = splited[0];
    }
    format = format.trim();
    return format;
};

export const setInputFilter = function (textbox, inputFilter) {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function (event) {
        textbox.addEventListener(event, function () {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            } else {
                this.value = "";
            }
        });
    });
};

export const updateQueryStringParameter = function (uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        return uri + separator + key + "=" + value;
    }
};

export const loadTawk = function (myShopifyDomain, ownerName) {
    window.Tawk_API = window.Tawk_API || {}; //, 
    window.Tawk_LoadStart = new Date();
    (function () {
        var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
        s1.async = true;
        s1.src = 'https://embed.tawk.to/627bfc5b7b967b11798ee626/1g2q53i70';
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');
        s0.parentNode.insertBefore(s1, s0);
    })();

    window.Tawk_API.onLoad = function () {
        window.Tawk_API.setAttributes({
            'shop': myShopifyDomain,
            'user': ownerName
        }, function (error) { });
    };
};

export const loadInspectlet = function () {
    (function () {
        window.__insp = window.__insp || [];
        window.__insp.push(['wid', 998537788]);
        var ldinsp = function () {
            if (typeof window.__inspld != "undefined") return; window.__inspld = 1; var insp = document.createElement('script'); insp.type = 'text/javascript'; insp.async = true; insp.id = "inspsync"; insp.src = ('https:' === document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js?wid=998537788&r=' + Math.floor(new Date().getTime() / 3600000); var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(insp, x);
        };
        setTimeout(ldinsp, 0);
    })();
};

export const addErrorMessage = function (container, errorBox, errorMessage, bgColor, color, iconColor) {
    if (errorBox === null) {
        errorBox = document.createElement("div");
        errorBox.classList.add('bdp-d-field-message');
        errorBox.classList.add('bdp-d-error');
        errorBox.setAttribute("style", 'background-color: ' + bgColor + '; color: ' + color + ';');

        container.appendChild(errorBox);
    }

    errorBox.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="' + iconColor + '"><path d="M16.971 5.657l-4.972 4.972-4.971-4.971-1.371 1.371L10.628 12l-4.971 4.971 1.371 1.371 4.971-4.971 4.972 4.972 1.371-1.371L13.37 12l4.972-4.972z" fill-rule="evenodd"/></svg><span>' + errorMessage + '</span>';
};

export const isEmpty = function (value) {
    if (Array.isArray(value)) {
        return value.length === 0;
    } else {
        return value === '' || value == null;
    }
};

export const fetchGet = async (url) => {
    var token = localStorage.getItem('token');

    const response = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!response.ok) {
        if (response.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        else {
            return { redirectUrl: '/error' };
        }
    }

    return await response.json();
};

export const fetchPost = async (url, model) => {
    var token = localStorage.getItem('token');

    const response = await fetch(url, { method: 'post', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify(model) });
    if (!response.ok) {
        if (response.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        else {
            return { redirectUrl: '/error' };
        }
    }

    return await response.json();
};

export const getNewDate = function (value) {
    var date;
    if (value) {
        date = new Date(value);
    }
    else {
        date = new Date();
    }

    date.setHours(0, 0, 0, 0);
    return date;
};

export const formatDate = function (value) {
    const offset = value.getTimezoneOffset();
    value = new Date(value.getTime() - (offset * 60 * 1000));
    return value.toISOString().split('T')[0];
};

export const currencyToFloat = function (value) {
    if (value === null) {
        return 0;
    }

    let newValue = value.toString().replace(/,/g, '');
    return parseFloat(newValue);
};

export const copyToClipboard = function (text, e) {
    let icon = null;
    if (e) {
        e.stopPropagation();
        icon = e.currentTarget?.querySelector('.Polaris-Icon');
    }
    navigator.clipboard.writeText(text)
        .then(() => {
            if (icon) {
                icon.innerHTML = '<svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true"><path fill-rule="evenodd" d="M15.78 5.97a.75.75 0 0 1 0 1.06l-6.5 6.5a.75.75 0 0 1-1.06 0l-3.25-3.25a.75.75 0 1 1 1.06-1.06l2.72 2.72 5.97-5.97a.75.75 0 0 1 1.06 0Z"/></svg>';
                setTimeout(function () {
                    icon.innerHTML = '<svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true"><path fill-rule="evenodd" d="M6.515 4.75a2 2 0 0 1 1.985-1.75h3a2 2 0 0 1 1.985 1.75h.265a2.25 2.25 0 0 1 2.25 2.25v7.75a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-7.75a2.25 2.25 0 0 1 2.25-2.25h.265Zm1.985-.25h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm-1.987 1.73.002.02h-.265a.75.75 0 0 0-.75.75v7.75c0 .414.336.75.75.75h7.5a.75.75 0 0 0 .75-.75v-7.75a.75.75 0 0 0-.75-.75h-.265a2 2 0 0 1-1.985 1.75h-3a2 2 0 0 1-1.987-1.77Z"></path></svg>';
                }, 1000);
            }
        })
        .catch(err => {
            console.error('Failed to copy:', err);
        });
};

export const isValidEmail = function (value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};

export const defaultInitSettings = { appEnabled: true, numberOfCampaigns: 0, showRating: false, showPromo: true, qsDateRange: 'allTime', campaignsCount: 0 };